import { render, staticRenderFns } from "./ednCopyPaste.vue?vue&type=template&id=0b593652"
import script from "./ednCopyPaste.vue?vue&type=script&lang=js"
export * from "./ednCopyPaste.vue?vue&type=script&lang=js"
import style0 from "./ednCopyPaste.vue?vue&type=style&index=0&id=0b593652&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports